export const miniPicksTestIds = {
  miniPicksBackButton: 'minipicks_back_button',
  miniPicksNextButton: 'minipicks_next_button',
  miniPick: 'mini-pick_test_id',
  gamesMiniPick: 'games-mini-pick_test_id',
};

export const buttonTestIds = {
  button: 'button',
  downloadButton: 'download_button',
  offerDownloadButton: 'offer_download_button',
  introButton: 'intro_button',
  copyLinkButton: 'copy_link_button',
};

export const footerTestIds = {
  footerLink: 'footer_link',
  footerTvLink: 'footer_tv_link',
  footerMediaKitLink: 'footer_mediakit_link',
  footerRustoreOpenLink: 'show_rustore_open_link',
  footerSocialLink: 'footer_social_link',
};

export const headerTestIds = {
  headerAppsLink: 'header_apps_link',
  headerGamesLink: 'header_games_link',
  headerDevelopersLink: 'header_developers_link',
  headerHelpLink: 'header_help_link',
  headerDownloadLink: 'header_download_link',
  DownloadRustoreButton: 'download_rustore_button',
  headerMenuButton: 'header_menu',
  headerCompoundLogo: 'compound_logo',
  navigationLink: 'navigation_link',
  closeMobileMenuButton: 'close_mobile_menu_button',
  mobileMenuItemButton: 'menu_item_button',
};

export const breadcrumbsTestIds = {
  link: 'breadcrumbs',
};
